import { render, staticRenderFns } from "./LearningUnitTree.vue?vue&type=template&id=64ce71da&scoped=true&"
import script from "./LearningUnitTree.vue?vue&type=script&lang=ts&"
export * from "./LearningUnitTree.vue?vue&type=script&lang=ts&"
import style0 from "./LearningUnitTree.vue?vue&type=style&index=0&id=64ce71da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce71da",
  null
  
)

export default component.exports